export const buildAnnualUserLogins = (chartDataRaw) => {
  const thisYear = new Date().getFullYear();
  const map = new Map();

  chartDataRaw.forEach((n) => {
    const year = new Date(n.logged_in_at.replace(" ", "T")).getFullYear();
    if (year !== thisYear) return;

    const name = n.user?.name ?? "Unknown";
    const role = n.user?.role ?? "No Role";

    const prev = map.get(name) ?? { name, role, jumlahLogin: 0 };
    prev.jumlahLogin += 1;
    map.set(name, prev);
  });

  return Array.from(map.values());
};
